/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * Hub collections
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetAdminHubCollectionSummaryParams,
  HubCollectionSummary
} from './model';

import { customFetch } from '../custom-fetch';
import type { ErrorType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetAdminHubCollectionSummaryUrl = (params: GetAdminHubCollectionSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/hub-collection-summary?${stringifiedParams}` : `/api/admin/hub-collection-summary`
}

/**
 * Read-only. Selected-order card fee receipts are distinct from provider-period costs, settlement-period repayments and current all-date debts. Mixed shop repayments include drivers. Null totals mean allocation incomplete, never zero.
 */
export const getAdminHubCollectionSummary = async (params: GetAdminHubCollectionSummaryParams, options?: RequestInit): Promise<HubCollectionSummary> => {

  return customFetch<HubCollectionSummary>(getGetAdminHubCollectionSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminHubCollectionSummaryQueryKey = (params?: GetAdminHubCollectionSummaryParams,) => {
    return [
    `/api/admin/hub-collection-summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminHubCollectionSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getAdminHubCollectionSummary>>, TError = ErrorType<void>>(params: GetAdminHubCollectionSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminHubCollectionSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminHubCollectionSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminHubCollectionSummary>>> = ({ signal }) => getAdminHubCollectionSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminHubCollectionSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminHubCollectionSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminHubCollectionSummary>>>
export type GetAdminHubCollectionSummaryQueryError = ErrorType<void>



export function useGetAdminHubCollectionSummary<TData = Awaited<ReturnType<typeof getAdminHubCollectionSummary>>, TError = ErrorType<void>>(
 params: GetAdminHubCollectionSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminHubCollectionSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminHubCollectionSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







